import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7hb3sm8fsk: FaireBrandEntity = {
  token: "b_7hb3sm8fsk",
  type: "brand",
  name: "LÚDERE",
  avatarUrl:
    "https://cdn.faire.com/fastly/c645cfd39417192425bcd7336081a7281b34a795361c34cc2884bdce6783f976.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e6f76c9b68a10df4d3daca3c4ec34d771d4760cb30142d3c5291e9875630cbb8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c645cfd39417192425bcd7336081a7281b34a795361c34cc2884bdce6783f976.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e6f76c9b68a10df4d3daca3c4ec34d771d4760cb30142d3c5291e9875630cbb8.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Hello! I'm Arielle, founder and designer behind LÚDERE. \n\nI create joyful, uncommon, and easy-to-wear mini sculptures for the body in 14k solid gold, gold vermeil, and sterling silver with natural gemstones. LÚDERE means \"to play.\" I was driven to create LÚDERE out of a passion for art & design and a desire to inspire individuals to live life as play. \n\nWhen you wear LÚDERE jewelry, you know you can take on anything. You approach life believing that anything is possible. \n\nFAQ:\nWhat is Gold Vermeil Jewelry & why do customers value it?\n\nNot to be confused with regular gold plating, our gold vermeil pieces are made with a layer of 18k gold at least 2.5 microns thick. That's 5x thicker than average gold plating and more durable. The base metal of vermeil is 925 sterling silver, whereas the base metal of plated jewelry is typically copper, brass, or steel. Vermeil jewelry is a much higher-quality and more valuable keepsake than plated jewelry.  Working in vermeil allows us to create pieces that have the look & feel of traditional gold jewelry at a price point more similar to sterling silver.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:03.235Z",
    importedBy: "entity-db-cli",
  },
};
